var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Rect, Circle, Ellipse, Polygon, Star, Path, Arc } from '../shapes/index';
export function beginShapeClip(ctx, node) {
    var e_1, _a;
    var _b, _c, _d;
    ctx.beginPath();
    if (node instanceof Rect) {
        var r = node.cornerRadius;
        if (r > 0) {
            roundRect(ctx, 0, 0, node.width, node.height, r);
        }
        else {
            ctx.rect(0, 0, node.width, node.height);
        }
    }
    else if (node instanceof Circle) {
        ctx.arc(node.radius, node.radius, node.radius, 0, Math.PI * 2);
    }
    else if (node instanceof Ellipse) {
        ctx.ellipse(node.radiusX, node.radiusY, node.radiusX, node.radiusY, 0, 0, Math.PI * 2);
    }
    else if (node instanceof Polygon) {
        var pts = node.points;
        if (pts.length >= 4) {
            ctx.moveTo(pts[0], pts[1]);
            for (var i = 2; i < pts.length; i += 2)
                ctx.lineTo(pts[i], pts[i + 1]);
            ctx.closePath();
        }
    }
    else if (node instanceof Star) {
        var pts = starPoints(node);
        ctx.moveTo(pts[0], pts[1]);
        for (var i = 2; i < pts.length; i += 2)
            ctx.lineTo(pts[i], pts[i + 1]);
        ctx.closePath();
    }
    else if (node instanceof Path) {
        ctx.clip(new Path2D(node.d));
        return;
    }
    else if (node instanceof Arc) {
        ctx.arc(node.radius, node.radius, node.radius, node.startAngle, node.endAngle, node.counterClockwise);
    }
    else if ('children' in node) {
        var g = node;
        var meta = (_b = g.metadata) !== null && _b !== void 0 ? _b : {};
        var state = meta.autoState;
        var aw = (_c = meta.autoWidth) !== null && _c !== void 0 ? _c : state === null || state === void 0 ? void 0 : state.width;
        var ah = (_d = meta.autoHeight) !== null && _d !== void 0 ? _d : state === null || state === void 0 ? void 0 : state.height;
        if (typeof aw === 'number' && typeof ah === 'number' && aw > 0 && ah > 0) {
            ctx.rect(0, 0, aw, ah);
        }
        else if (g.children.length === 0) {
            ctx.rect(0, 0, 0, 0);
        }
        else {
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            try {
                for (var _e = __values(g.children), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var child = _f.value;
                    var b = child.getBounds();
                    var x0 = child.x + b.x;
                    var y0 = child.y + b.y;
                    minX = Math.min(minX, x0);
                    minY = Math.min(minY, y0);
                    maxX = Math.max(maxX, x0 + b.width);
                    maxY = Math.max(maxY, y0 + b.height);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                }
                finally { if (e_1) throw e_1.error; }
            }
            ctx.rect(minX, minY, maxX - minX, maxY - minY);
        }
    }
    else {
        var b = node.getBounds();
        ctx.rect(b.x, b.y, b.width, b.height);
    }
    ctx.clip();
}
function starPoints(node) {
    var pts = [];
    var cx = node.outerRadius;
    var cy = node.outerRadius;
    for (var i = 0; i < node.numPoints * 2; i++) {
        var r = i % 2 === 0 ? node.outerRadius : node.innerRadius;
        var angle = (i * Math.PI) / node.numPoints - Math.PI / 2;
        pts.push(cx + r * Math.cos(angle), cy + r * Math.sin(angle));
    }
    return pts;
}
function roundRect(ctx, x, y, w, h, r) {
    r = Math.min(r, w / 2, h / 2);
    ctx.moveTo(x + r, y);
    ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    ctx.lineTo(x + w, y + h - r);
    ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y);
    ctx.closePath();
}
export function pointInMask(mask, localX, localY) {
    if (!mask)
        return true;
    return mask.containsPoint(localX - mask.x, localY - mask.y);
}
